import { Dashboard } from "components";
import SettingsView from "./SettingsView";

export const SettingsContainer = () => {
  return (
    <Dashboard>
      <SettingsView />
    </Dashboard>
  );
};
